/** @jsxImportSource @emotion/react */
import { FC } from 'react'
import { Typography } from '../Typography'
import { Number } from './styles'

export const SeatNumberBox: FC<{
  seatNumber: number
}> = ({ seatNumber }) => {
  return (
    <Number>
      <Typography variant="text3" as="span">
        {seatNumber}
      </Typography>
    </Number>
  )
}
